import type { CSSProperties } from 'react'

export const getVariant = (
  id: string,
  planId: string,
  loadingId: string | null,
  planIndex: number,
  types: string[]
) => {
  return id === loadingId
    ? 'loading'
    : id === planId
      ? 'selected'
      : planIndex > types.indexOf(id)
        ? 'downgrade'
        : 'upgrade'
}

// The kit button paints primary with --accent: the plan color fills it and,
// on hover, becomes its border and text
export const getButtonStyle = (color: string) =>
  ({ '--accent': color }) as CSSProperties

export const getButtonText = (id: string, planId: string) => {
  switch (id) {
    case planId:
      return 'Current plan'
    default:
      return 'Choose plan'
  }
}
